import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';

import { updateSettings } from '../../settings'
import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

//import { data } from './data';
import { fetchIntro, getIntro } from './redux'

class Introduction extends Component {

    state = {

    }

    static fetchData(store, match) {
        return store.dispatch(fetchIntro()); 
    }

    componentDidMount = () => {
        const { updateSettings } = this.props;

        this.props.fetchIntro()

        updateSettings({
            pageTitle: 'Introduction'
        })
    }

    render() {
        const { intro } = this.props;
       
        return (
            <Container>
                
                {intro.data && (
                    <Heading>{intro.data.heading}</Heading>
                )}
                
                <Content>
                    {intro.data && (
                        <Text
                            dangerouslySetInnerHTML={{__html: intro.data.text_column_1}}
                        />
                    )}     
                    
                    {intro.data && intro.data.text_column_2.length && (
                        <Text
                            dangerouslySetInnerHTML={{__html: intro.data.text_column_2}}
                        />
                    )}
                </Content>
            </Container>
        )
        
        
    }
}

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    ${padding}
    padding-top: 12px;
    overflow-y: scroll;
    max-height: calc(100vh - 65px); 
    box-sizing: border-box;

    ${media.phone`
        flex-direction: column;
    `}
`

const Heading = styled.div`
    font-weight: bold;
    margin-bottom: 18px;
`

const Content = styled.div`
    display: flex;
`

const Text = styled.div`
    flex: 1;
    font-size: 16px;
    color: #000000;
    white-space: pre-line;
    margin-bottom: 64px;
    line-height: 19px;

    strong {
        font-weight: bold;
    }

    &:first-child {
        padding-right: 16px;
    }
`


const mapDispatchToProps = dispatch => ({
    fetchIntro() {
        dispatch(fetchIntro())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    intro: getIntro(state)
})


export default connect(mapStateToProps, mapDispatchToProps)(Introduction);



// WEBPACK FOOTER //
// ./client/modules/Introduction/Introduction.js